// Storage keys
export const QuestionnaireStorageKeys = {
  SELECTED_CHOICES: "introQuestions_selectedChoices",
  OTHER_INPUTS: "introQuestions_otherInputs",
  EMPLOYMENT_STATUS: "introQuestions_employmentStatus",
  ANNUAL_INCOME: "introQuestions_annualIncome",
  FUNDING_SOURCE: "introQuestions_fundingSource",
  LIQUID_NET_WORTH: "introQuestions_liquidNetWorth",
  AFFILIATIONS: "introQuestions_affiliations",
};

// Employment status mapping
export const EMPLOYMENT_STATUS_MAP = {
  employed: "employed",
  unemployed: "unemployed",
  retired: "retired",
  student: "student",
};

// Funding source mapping
export const FUNDING_SOURCE_MAP = {
  employment_income: "employment_income",
  investments: "investments",
  inheritance: "inheritance",
  business_income: "business_income",
  savings: "savings",
};

// Employment status options
export const EMPLOYMENT_STATUS_OPTIONS = [
  { label: "Employed", value: "employed" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Retired", value: "retired" },
  { label: "Student", value: "student" },
];

// Annual income options
export const ANNUAL_INCOME_OPTIONS = [
  { text: "Under $25,000", slug: "Under $25,000" },
  { text: "$25,001 - $50,000", slug: "$25,001 - $50,000" },
  { text: "$50,001 - $100,000", slug: "$50,001 - $100,000" },
  { text: "$100,001 - $200,000", slug: "$100,001 - $200,000" },
  { text: "$200,001 - $300,000", slug: "$200,001 - $300,000" },
  { text: "$300,001 - $500,000", slug: "$300,001 - $500,000" },
  { text: "$500,001 - $900,000", slug: "$500,001 - $900,000" },
  { text: "$900,001 - $100,000,000", slug: "$900,001 - $100,000,000" },
];

// Funding source options
export const FUNDING_SOURCE_OPTIONS = [
  { label: "Employment Income", value: "employment_income" },
  { label: "Investments", value: "investments" },
  { label: "Inheritance", value: "inheritance" },
  { label: "Business Income", value: "business_income" },
  { label: "Savings", value: "savings" },
];

// Liquid net worth options
export const LIQUID_NET_WORTH_OPTIONS = [
  { text: "Under $25,000", slug: "Under $25,000" },
  { text: "$25,001 - $50,000", slug: "$25,001 - $50,000" },
  { text: "$50,001 - $100,000", slug: "$50,001 - $100,000" },
  { text: "$100,001 - $200,000", slug: "$100,001 - $200,000" },
  { text: "$200,001 - $300,000", slug: "$200,001 - $300,000" },
  { text: "$300,001 - $500,000", slug: "$300,001 - $500,000" },
];

// Affiliation options
export const AFFILIATION_OPTIONS = [
  {
    label: "I am a control person",
    value: "control_person",
    slug: "control_person",
  },
  {
    label: "I am affiliated with a stock exchange or FINRA",
    value: "affiliated_exchange_or_finra",
    slug: "affiliated_exchange_or_finra",
  },
  {
    label: "I am a politically exposed person (PEP)",
    value: "politically_exposed",
    slug: "politically_exposed",
  },
  {
    label:
      "I have an immediate family member who is a politically exposed person",
    value: "immediate_family_exposed",
    slug: "immediate_family_exposed",
  },
];
